import Text from '@shared/components/content/text';
import Unit, { UnitVariant } from '@shared/components/content/unit';
import { cn } from '@shared/lib/utils';

interface PreviewSheetSectionProps {
  title: string;
  unit?: UnitVariant;
  className?: string;
  children: React.ReactNode;
}

export default function PreviewSheetSection({
  title,
  unit,
  className,
  children,
}: PreviewSheetSectionProps) {
  return (
    <div className={cn('flex flex-col', className)}>
      <div className="flex w-full items-center justify-between rounded-t-lg bg-primary-50 p-3 py-2">
        <Text className="text-sm font-semibold text-primary-700">{title}</Text>
        {unit && <Unit variant={unit} />}
      </div>
      {children}
    </div>
  );
}
